import { useUser } from '@descope/react-sdk';
import {
  Button,
  createStyles,
  Group,
  LoadingOverlay,
  Stack,
  TextInput,
} from '@mantine/core';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useCreateUser, useUsers } from '@portals/api/ui';

import { useSignUpWizard } from '../../../pages/Sign-up/wizard/wizard.hooks';
import { StepSubtitle, StepTitle } from '../common';
import { UserCard } from '../UserCard';

export function InviteCoWorkers() {
  const { classes } = useStyles();
  const { isNextDisabled } = useSignUpWizard();

  const navigate = useNavigate();

  const createUser = useCreateUser();
  const users = useUsers();
  const { user } = useUser();

  const currentUser = {
    name: `${user.name} (You)`,
    email: user.email,
  };

  const adjustedUsers = users.data?.filter(
    (user) => user.email !== currentUser.email
  );

  const [userEmail, setUserEmail] = React.useState('');

  const onAddUser = (e) => {
    e.preventDefault();
    createUser.mutate({ email: userEmail });
  };

  const handleFinish = (e) => {
    e.preventDefault();

    navigate('/');
  };

  return (
    <>
      <LoadingOverlay visible={users.isLoading || createUser.isLoading} />
      <Stack w={455}>
        <StepTitle>Time to invite your teammates</StepTitle>
        <StepSubtitle mb="xxl">
          Collaborate with your team to get the most out of Xyte.io
        </StepSubtitle>

        <Stack spacing="lg">
          <form onSubmit={onAddUser}>
            <Stack spacing="md">
              <Group>
                <TextInput
                  className={classes.textInput}
                  type="email"
                  placeholder="Teammate email address"
                  onChange={(e) => setUserEmail(e.target.value)}
                />

                <Button
                  variant="light"
                  type="submit"
                  disabled={userEmail.trim() === ''}
                >
                  Send Invitation
                </Button>
              </Group>

              <UserCard email={currentUser.email} name={user.name} />

              {adjustedUsers?.map(({ name, email }) => (
                <UserCard
                  email={email}
                  name={name}
                  key={email}
                  isInvitationSent
                />
              ))}

              <Button
                fullWidth
                mt="xl"
                data-testid="finish-button"
                disabled={isNextDisabled || users.data?.length === 0}
                onClick={handleFinish}
              >
                Finish
              </Button>
            </Stack>
          </form>
        </Stack>
      </Stack>
    </>
  );
}

const useStyles = createStyles((theme) => ({
  textInput: {
    flexGrow: 1,
  },
}));
